import { render } from "./form.vue?vue&type=template&id=6645ff39"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=6645ff39&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__